export const FooterResourcesDA = {
  impressum: "Impressum",
  contact: "Kontakt",
  followUs: "Følg os",
  rights: "Alle rettigheder forbeholdes",
};

export const FooterResourcesEN = {
  impressum: "Impressum",
  contact: "Contact",
  followUs: "Follow us",
  rights: "All rights reserved",
};

export const FooterResourcesDE = {
  impressum: "Impressum",
  contact: "Kontakt",
  followUs: "Folgen Sie uns",
  rights: "Alle Rechte vorbehalten",
};

export const FooterResourcesBS = {
  impressum: "Impresum",
  contact: "Kontakt",
  followUs: "Pratite nas",
  rights: "Sva prava zadržana",
};
